import React from 'react'
import styles from './Annotation.module.css'

const Annotation = () => {
    return (
        <p className={styles.annotation}>
            ※2026年4月期_飲食業界特化の求人サイトにおける市場調査 / 調査機関：日本マーケティングリサーチ機構
            調査期間：2026年1月15日～2026年4月21日 / 調査手法：主要6社（当社調べ）に関するデスクリサーチ /
            備考：2026年4月時点の実績値/効果効能等や優位性を保証するものではございません。
        </p>
    )
}

export default Annotation
